import {
  CreationUserEnum,
  FieldFormEnum,
  PaymentStatusEnum,
  QuestionEnum,
  StatusEnum,
  UniqueCreationEnum,
} from '@helpers/enums';

export interface IPivot {
  notification_id: number | null;
  read: QuestionEnum;
  user_id: number | null;
  negotiations_types_status_id: number | null;
  briefs_type_id: number | null;
  detail_id: number | null;
  status: StatusEnum;
  order: number | null;
  autocomplete_history: QuestionEnum;
  required: QuestionEnum;
  entities_type_id: number | null;
  field_id: number | null;
  field_order: number | null;
  creatable: FieldFormEnum;
  editable: FieldFormEnum;
  unique_creation: UniqueCreationEnum;
  interactions_types_status_id: number | null;
  activity_id: number | null;
  is_finished: QuestionEnum;
  creation_required: QuestionEnum;
  creation_user: CreationUserEnum;
  section_id: number | null;
  table_id: number | null;
  required_negotiation: QuestionEnum;
  negotiations_type_id: number | null;
  groups_category_id: number | null;
  negotiation_id: number | null;
  profile_id: number | null;
  value_day: number | null;
  value_month: number | null;
  value_week: number | null;
  value_year: number | null;
  viewers_budget_id: number | null;
  viewers_kpi_id: number | null;
  show_in: string;
  briefs_types_status_id: number | null;
  processes_types_status_id: number | null;
  type: string;
  initial_status_payments: StatusEnum;
  payment_periods_min: number | null;
  required_payment_period: QuestionEnum;
  initial_status_payments_office: PaymentStatusEnum | null;
  default: QuestionEnum;
  current_negotiations_types_status_id: number | null;
  additionals_informations_option_id: number | null;
  additionals_information_negotiatiation_related_id?: number | null;
}

class PivotClass implements IPivot {
  notification_id = null;
  read = QuestionEnum.NO;
  user_id = null;
  negotiations_types_status_id = null;
  briefs_type_id = null;

  detail_id = null;
  status = StatusEnum.ACTIVE;
  order = null;
  autocomplete_history = QuestionEnum.NO;
  required = QuestionEnum.NO;
  entities_type_id = null;
  field_id = null;
  field_order = null;
  creatable = FieldFormEnum.NO;
  editable = FieldFormEnum.NO;
  unique_creation = UniqueCreationEnum.NO;
  interactions_types_status_id = null;
  activity_id = null;
  is_finished = QuestionEnum.NO;
  creation_required = QuestionEnum.NO;
  creation_user = CreationUserEnum.ALL;
  section_id = null;
  table_id = null;
  required_negotiation = QuestionEnum.NO;
  negotiations_type_id = null;
  groups_category_id = null;
  negotiation_id = null;
  profile_id = null;
  value_day = null;
  value_month = null;
  value_week = null;
  value_year = null;
  viewers_budget_id = null;
  viewers_kpi_id = null;
  show_in = '';
  briefs_types_status_id = null;
  processes_types_status_id = null;
  additionals_informations_option_id = null;
  type = '';
  initial_status_payments = StatusEnum.PAID;
  payment_periods_min = 0;
  required_payment_period = QuestionEnum.NO;
  initial_status_payments_office = null;
  default = QuestionEnum.NO;
  current_negotiations_types_status_id = null;
}

export default PivotClass;
